import React, { useEffect, useState } from "react";
import { api, errMsg, formatDate } from "../lib/api";
import { History, X } from "lucide-react";
import { toast } from "sonner";

export default function AuditDrawer({ projectId, open, onClose }) {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    api.get(`/projects/${projectId}/audit`)
      .then(({ data }) => setEntries(data))
      .catch((e) => toast.error(errMsg(e)))
      .finally(() => setLoading(false));
  }, [open, projectId]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex" data-testid="audit-drawer">
      <div className="flex-1 bg-black/50" onClick={onClose}></div>
      <aside className="w-full max-w-md bg-slate-950 border-l border-slate-800 h-full flex flex-col">
        <header className="pc-glass-header px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2 text-white">
            <History size={16}/> <span className="font-semibold" style={{fontFamily:'Outfit'}}>Audit log</span>
          </div>
          <button onClick={onClose} className="text-slate-400 hover:text-white" data-testid="audit-close"><X size={18}/></button>
        </header>
        <div className="flex-1 overflow-y-auto p-4 space-y-2">
          {loading ? <div className="text-slate-400">Loading…</div>
            : entries.length === 0 ? <div className="text-slate-500 text-sm">No activity yet.</div>
            : entries.map((e) => <AuditEntry key={e.id} e={e}/>)}
        </div>
      </aside>
    </div>
  );
}

function AuditEntry({ e }) {
  const action = e.action.replace("task.", "");
  const tone = action === "deleted" ? "border-rose-500/40" : action === "created" ? "border-emerald-500/40" : "border-blue-500/40";
  return (
    <div className={`pc-card p-3 border-l-2 ${tone}`} data-testid={`audit-${e.id}`}>
      <div className="flex items-center justify-between">
        <div className="text-xs text-slate-400"><span className="text-white font-medium">{e.actor_name}</span> {action} <span className="text-slate-200">{e.meta?.name || e.entity_id}</span></div>
        <div className="text-[10px] text-slate-500">{formatDate(e.created_at)}</div>
      </div>
      {e.meta?.changes && (
        <div className="mt-2 space-y-0.5">
          {Object.entries(e.meta.changes).slice(0, 4).map(([k, v]) => (
            <div key={k} className="text-[11px] text-slate-400">
              <span className="text-slate-500">{k}:</span> <span className="text-rose-300 line-through">{fmt(v.from)}</span> <span className="text-slate-500">→</span> <span className="text-emerald-300">{fmt(v.to)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function fmt(v) { if (v === null || v === undefined || v === "") return "∅"; return String(v); }
